import { Navigate } from "react-router-dom";
import { useAuth } from "../contexts/auth-context";

function hasAccountClaims(accessToken: string | undefined): boolean {
  if (!accessToken) return false;
  try {
    const payload = JSON.parse(atob(accessToken.split(".")[1]));
    const meta = payload.app_metadata;
    return Boolean(meta?.account_id) && Boolean(meta?.business_id);
  } catch {
    return false;
  }
}

export function ProtectedRoute({ children }: { children: React.ReactNode }) {
  const { session, isLoading } = useAuth();

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        Loading...
      </div>
    );
  }

  if (!session) {
    return <Navigate to="/login" replace />;
  }

  if (!hasAccountClaims(session.access_token)) {
    return <Navigate to="/no-account" replace />;
  }

  return <>{children}</>;
}
